// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page */
.adminJournalPage{
  background: var(--white-principale);
  min-height: 100vh;
  padding: 12px 0 26px;
  font-family: Arial, sans-serif;
}

/* Grid (carte centrée) */
.adminJournalGrid{
  display:flex;
  justify-content: center;
}

/* Card */
.adminJournalCard{
  border-radius: 12px;
  background: var(--white-principale);
  box-shadow: 0 1px 10px rgba(0,0,0,.14);
  padding: 16px;
}

.adminJournalCardCenter{
  width: 100%;
  max-width: 1100px;
  margin-top: 16px;
}

/* Header */
.adminJournalHeader{
  display:flex;
  align-items:flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.adminJournalTitle{
  font-weight: 900;
  font-size: 14px;
  color: var(--couleur-dark);
}

.adminJournalSubtitle{
  margin-top: 4px;
  font-size: 12px;
  color: var(--gris-terciaire);
}

/* Buttons */
.adminJournalBtn{
  border: none;
  border-radius: 999px;
  padding: 8px 12px;
  font-weight: 800;
  font-size: 12px;
  cursor: pointer;
  display:flex;
  align-items:center;
  gap: 8px;
  transition: filter .15s ease, opacity .15s ease;
}

.adminJournalBtnSoft{
  background: rgba(0,0,0,.06);
  color: var(--couleur-dark);
}

.adminJournalBtnSoft:hover{
  filter: brightness(0.96);
}

.adminJournalBtn:disabled{
  opacity: .6;
  cursor: default;
}

/* Filters */
.adminJournalFilters{
  display:flex;
  align-items:center;
  gap: 12px;
  flex-wrap: wrap;
  margin: 12px 0 14px;
}

.adminJournalSearch{
  flex: 1 1 360px;
  min-width: 260px;
  display:flex;
  align-items:center;
  gap: 8px;
  border: 1px solid var(--gris-secondaire-2);
  border-radius: 999px;
  padding: 8px 12px;
  background: var(--white-principale);
}

.adminJournalSearch i{
  color: var(--gris-terciaire);
}

.adminJournalSearch input{
  border: none;
  outline: none;
  width: 100%;
  font-size: 12px;
  color: var(--couleur-dark);
  background: transparent;
}

.adminJournalSelects{
  display:flex;
  gap: 10px;
  flex-wrap: wrap;
}

.adminJournalSelects select{
  height: 34px;
  border-radius: 10px;
  border: 1px solid var(--gris-secondaire-2);
  padding: 0 10px;
  font-size: 12px;
  color: var(--couleur-dark);
  background: var(--white-principale);
  outline: none;
}

/* Table */
.adminJournalTableWrap{
  width: 100%;
  overflow-x: auto;
  border: 1px solid var(--gris-secondaire-2);
  border-radius: 12px;
}

.adminJournalTable{
  width: 100%;
  border-collapse: collapse;
  min-width: 760px;
}

.adminJournalTable thead th{
  text-align: left;
  font-size: 11px;
  color: var(--gris-terciaire);
  font-weight: 900;
  padding: 12px 12px;
  background: rgba(0,0,0,.03);
  border-bottom: 1px solid var(--gris-secondaire-2);
}

.adminJournalTable tbody td{
  padding: 12px 12px;
  border-bottom: 1px solid rgba(0,0,0,.06);
  font-size: 12px;
  color: var(--couleur-dark);
  vertical-align: middle;
}

.adminJournalTable tbody tr:hover{
  background: rgba(0,0,0,.02);
}

.muted{
  color: var(--gris-terciaire);
}

.nowrap{
  white-space: nowrap;
}

/* Message cell */
.adminJournalMessage{
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 420px;
  line-height: 1.35;
}

/* Badges */
.adminJournalBadge{
  display:inline-flex;
  align-items:center;
  height: 22px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: .02em;
  border: 1px solid rgba(0,0,0,.08);
  white-space: nowrap;
}

.badgeCaptcha{
  background: rgba(255, 176, 32, .14);
  color: #b3790a;
  border-color: rgba(255, 176, 32, .22);
}

.badgeGoogle{
  background: rgba(220, 53, 69, .12);
  color: #dc3545;
  border-color: rgba(220, 53, 69, .18);
}

.badgeMail{
  background: rgba(43, 80, 255, .12);
  color: var(--couleur-principale);
  border-color: rgba(43, 80, 255, .18);
}

.badgeFacebook{
  background: rgba(23, 107, 239, .12);
  color: #176bef;
  border-color: rgba(23, 107, 239, .18);
}

.badgeArchived{
  background: rgba(0,0,0,.06);
  color: var(--couleur-dark);
}

.badgeNotArchived{
  background: rgba(28,180,93,.12);
  color: #1cb45d;
  border-color: rgba(28,180,93,.18);
}

/* Actions */
.colActions{
  width: 96px;
}

.adminJournalActions{
  display:flex;
  justify-content:flex-end;
  gap: 8px;
}

.adminJournalIconBtn{
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: 1px solid rgba(0,0,0,.08);
  background: var(--white-principale);
  display:flex;
  align-items:center;
  justify-content:center;
  cursor: pointer;
  transition: filter .15s ease, transform .06s ease;
}

.adminJournalIconBtn:hover{
  filter: brightness(0.98);
}

.adminJournalIconBtn:active{
  transform: scale(0.98);
}

.adminJournalIconBtn:disabled{
  opacity: .55;
  cursor: default;
}

.adminJournalIconBtn.danger{
  border-color: rgba(220,53,69,.25);
  color: #dc3545;
}

/* Empty / Loading */
.adminJournalEmpty{
  padding: 22px 8px;
  display:flex;
  flex-direction: column;
  align-items:center;
  justify-content:center;
  gap: 10px;
  color: var(--gris-terciaire);
  text-align:center;
}

.adminJournalEmpty i{
  font-size: 22px;
}

.adminJournalSkeletonWrap{
  width: 100%;
  border: 1px solid var(--gris-secondaire-2);
  border-radius: 12px;
  padding: 40px 12px;
  display:flex;
  align-items:center;
  justify-content:center;
  background: var(--white-principale);
}

.adminJournalSpinner{
  width: 22px;
  height: 22px;
  border-radius: 999px;
  border: 2px solid rgba(0,0,0,.18);
  border-top-color: rgba(0,0,0,.45);
  animation: adminJournalSpin .8s linear infinite;
}

@keyframes adminJournalSpin{
  to { transform: rotate(360deg); }
}

/* Pagination */
.adminJournalPagination{
  margin-top: 14px;
  display:flex;
  align-items:center;
  justify-content:center;
  gap: 10px;
}

.adminJournalPageBtn{
  width: 36px;
  height: 36px;
  border-radius: 12px;
  border: 1px solid rgba(0,0,0,.08);
  background: var(--white-principale);
  cursor: pointer;
  display:flex;
  align-items:center;
  justify-content:center;
  transition: filter .15s ease;
}

.adminJournalPageBtn:hover{
  filter: brightness(0.98);
}

.adminJournalPageBtn:disabled{
  opacity: .55;
  cursor: default;
}

.adminJournalPageInfo{
  font-size: 12px;
  color: var(--gris-terciaire);
}

/* Responsive */
.hideOnMobile { display: table-cell; }
.adminJournalMobileMeta { display: none; }

@media (max-width: 720px){
  .hideOnMobile { display: none !important; }

  .adminJournalTable{ min-width: 0; }
  .adminJournalTable thead{ display:none; }

  .adminJournalTable,
  .adminJournalTableWrap{
    border: none;
  }

  .adminJournalTable tbody{
    display:flex;
    flex-direction: column;
    gap: 10px;
  }

  .adminJournalTable tbody tr{
    display:block;
    border: 1px solid var(--gris-secondaire-2);
    border-radius: 14px;
    padding: 10px;
    background: var(--white-principale);
  }

  .adminJournalTable tbody td{
    display:block;
    border-bottom: none;
    padding: 6px 4px;
  }

  .colActions{
    width: auto;
  }

  .adminJournalActions{
    justify-content: flex-end;
    margin-top: 6px;
  }

  .adminJournalMessage{
    -webkit-line-clamp: 3;
    max-width: 100%;
  }

  .adminJournalMobileMeta{
    display:block;
    margin-top: 8px;
    font-size: 11px;
    color: var(--gris-terciaire);
    line-height: 1.35;
  }

  .adminJournalMobileMeta div{
    display:flex;
    align-items:center;
    gap: 8px;
    margin-top: 4px;
  }

  .adminJournalMobileMeta i{
    opacity: .8;
  }
}

/* Modal de confirmation (suppression) */
.adminJournalModalOverlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 16px;
}

.adminJournalModal {
  width: 100%;
  max-width: 390px;
  background: var(--white-principale);
  border-radius: 18px;
  padding: 22px;
  text-align: center;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.22);
  animation: adminJournalModalIn 0.18s ease;
}

@keyframes adminJournalModalIn {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.adminJournalModalIcon {
  width: 52px;
  height: 52px;
  border-radius: 999px;
  margin: 0 auto 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
  font-size: 24px;
}

.adminJournalModal h3 {
  margin: 0;
  font-size: 17px;
  font-weight: 900;
  color: var(--couleur-dark);
}

.adminJournalModal p {
  margin: 10px 0;
  font-size: 13px;
  color: var(--gris-terciaire);
  line-height: 1.45;
}

.adminJournalModalActions {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 18px;
}

.adminJournalModalCancel,
.adminJournalModalConfirm {
  border: none;
  border-radius: 999px;
  padding: 9px 16px;
  font-size: 12px;
  font-weight: 900;
  cursor: pointer;
}

.adminJournalModalCancel {
  background: rgba(0, 0, 0, 0.07);
  color: var(--couleur-dark);
}

.adminJournalModalConfirm.danger {
  background: #dc3545;
  color: #fff;
}

.adminJournalModalCancel:hover,
.adminJournalModalConfirm:hover {
  filter: brightness(0.96);
}`, "",{"version":3,"sources":["webpack://./src/assets/css/admin/gestionJournal/AdminJournalPage.css"],"names":[],"mappings":"AAAA,SAAS;AACT;EACE,mCAAmC;EACnC,iBAAiB;EACjB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,mCAAmC;EACnC,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,YAAY;EACZ,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,0CAA0C;EAC1C,oBAAoB;EACpB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,mCAAmC;EACnC,aAAa;AACf;;AAEA,UAAU;AACV;EACE,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,iCAAiC;AACnC;;AAEA,YAAY;AACZ;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iCAAiC;EACjC,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,mCAAmC;EACnC,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,eAAe;AACf,gBAAgB,mBAAmB,EAAE;AACrC,0BAA0B,aAAa,EAAE;;AAEzC;EACE,gBAAgB,wBAAwB,EAAE;;EAE1C,oBAAoB,YAAY,EAAE;EAClC,0BAA0B,YAAY,EAAE;;EAExC;;IAEE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,mCAAmC;EACrC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,eAAe;IACf,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,wBAAwB;AAC1B","sourcesContent":["/* Page */\n.adminJournalPage{\n  background: var(--white-principale);\n  min-height: 100vh;\n  padding: 12px 0 26px;\n  font-family: Arial, sans-serif;\n}\n\n/* Grid (carte centrée) */\n.adminJournalGrid{\n  display:flex;\n  justify-content: center;\n}\n\n/* Card */\n.adminJournalCard{\n  border-radius: 12px;\n  background: var(--white-principale);\n  box-shadow: 0 1px 10px rgba(0,0,0,.14);\n  padding: 16px;\n}\n\n.adminJournalCardCenter{\n  width: 100%;\n  max-width: 1100px;\n  margin-top: 16px;\n}\n\n/* Header */\n.adminJournalHeader{\n  display:flex;\n  align-items:flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.adminJournalTitle{\n  font-weight: 900;\n  font-size: 14px;\n  color: var(--couleur-dark);\n}\n\n.adminJournalSubtitle{\n  margin-top: 4px;\n  font-size: 12px;\n  color: var(--gris-terciaire);\n}\n\n/* Buttons */\n.adminJournalBtn{\n  border: none;\n  border-radius: 999px;\n  padding: 8px 12px;\n  font-weight: 800;\n  font-size: 12px;\n  cursor: pointer;\n  display:flex;\n  align-items:center;\n  gap: 8px;\n  transition: filter .15s ease, opacity .15s ease;\n}\n\n.adminJournalBtnSoft{\n  background: rgba(0,0,0,.06);\n  color: var(--couleur-dark);\n}\n\n.adminJournalBtnSoft:hover{\n  filter: brightness(0.96);\n}\n\n.adminJournalBtn:disabled{\n  opacity: .6;\n  cursor: default;\n}\n\n/* Filters */\n.adminJournalFilters{\n  display:flex;\n  align-items:center;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin: 12px 0 14px;\n}\n\n.adminJournalSearch{\n  flex: 1 1 360px;\n  min-width: 260px;\n  display:flex;\n  align-items:center;\n  gap: 8px;\n  border: 1px solid var(--gris-secondaire-2);\n  border-radius: 999px;\n  padding: 8px 12px;\n  background: var(--white-principale);\n}\n\n.adminJournalSearch i{\n  color: var(--gris-terciaire);\n}\n\n.adminJournalSearch input{\n  border: none;\n  outline: none;\n  width: 100%;\n  font-size: 12px;\n  color: var(--couleur-dark);\n  background: transparent;\n}\n\n.adminJournalSelects{\n  display:flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.adminJournalSelects select{\n  height: 34px;\n  border-radius: 10px;\n  border: 1px solid var(--gris-secondaire-2);\n  padding: 0 10px;\n  font-size: 12px;\n  color: var(--couleur-dark);\n  background: var(--white-principale);\n  outline: none;\n}\n\n/* Table */\n.adminJournalTableWrap{\n  width: 100%;\n  overflow-x: auto;\n  border: 1px solid var(--gris-secondaire-2);\n  border-radius: 12px;\n}\n\n.adminJournalTable{\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 760px;\n}\n\n.adminJournalTable thead th{\n  text-align: left;\n  font-size: 11px;\n  color: var(--gris-terciaire);\n  font-weight: 900;\n  padding: 12px 12px;\n  background: rgba(0,0,0,.03);\n  border-bottom: 1px solid var(--gris-secondaire-2);\n}\n\n.adminJournalTable tbody td{\n  padding: 12px 12px;\n  border-bottom: 1px solid rgba(0,0,0,.06);\n  font-size: 12px;\n  color: var(--couleur-dark);\n  vertical-align: middle;\n}\n\n.adminJournalTable tbody tr:hover{\n  background: rgba(0,0,0,.02);\n}\n\n.muted{\n  color: var(--gris-terciaire);\n}\n\n.nowrap{\n  white-space: nowrap;\n}\n\n/* Message cell */\n.adminJournalMessage{\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  max-width: 420px;\n  line-height: 1.35;\n}\n\n/* Badges */\n.adminJournalBadge{\n  display:inline-flex;\n  align-items:center;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 900;\n  letter-spacing: .02em;\n  border: 1px solid rgba(0,0,0,.08);\n  white-space: nowrap;\n}\n\n.badgeCaptcha{\n  background: rgba(255, 176, 32, .14);\n  color: #b3790a;\n  border-color: rgba(255, 176, 32, .22);\n}\n\n.badgeGoogle{\n  background: rgba(220, 53, 69, .12);\n  color: #dc3545;\n  border-color: rgba(220, 53, 69, .18);\n}\n\n.badgeMail{\n  background: rgba(43, 80, 255, .12);\n  color: var(--couleur-principale);\n  border-color: rgba(43, 80, 255, .18);\n}\n\n.badgeFacebook{\n  background: rgba(23, 107, 239, .12);\n  color: #176bef;\n  border-color: rgba(23, 107, 239, .18);\n}\n\n.badgeArchived{\n  background: rgba(0,0,0,.06);\n  color: var(--couleur-dark);\n}\n\n.badgeNotArchived{\n  background: rgba(28,180,93,.12);\n  color: #1cb45d;\n  border-color: rgba(28,180,93,.18);\n}\n\n/* Actions */\n.colActions{\n  width: 96px;\n}\n\n.adminJournalActions{\n  display:flex;\n  justify-content:flex-end;\n  gap: 8px;\n}\n\n.adminJournalIconBtn{\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  border: 1px solid rgba(0,0,0,.08);\n  background: var(--white-principale);\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  cursor: pointer;\n  transition: filter .15s ease, transform .06s ease;\n}\n\n.adminJournalIconBtn:hover{\n  filter: brightness(0.98);\n}\n\n.adminJournalIconBtn:active{\n  transform: scale(0.98);\n}\n\n.adminJournalIconBtn:disabled{\n  opacity: .55;\n  cursor: default;\n}\n\n.adminJournalIconBtn.danger{\n  border-color: rgba(220,53,69,.25);\n  color: #dc3545;\n}\n\n/* Empty / Loading */\n.adminJournalEmpty{\n  padding: 22px 8px;\n  display:flex;\n  flex-direction: column;\n  align-items:center;\n  justify-content:center;\n  gap: 10px;\n  color: var(--gris-terciaire);\n  text-align:center;\n}\n\n.adminJournalEmpty i{\n  font-size: 22px;\n}\n\n.adminJournalSkeletonWrap{\n  width: 100%;\n  border: 1px solid var(--gris-secondaire-2);\n  border-radius: 12px;\n  padding: 40px 12px;\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  background: var(--white-principale);\n}\n\n.adminJournalSpinner{\n  width: 22px;\n  height: 22px;\n  border-radius: 999px;\n  border: 2px solid rgba(0,0,0,.18);\n  border-top-color: rgba(0,0,0,.45);\n  animation: adminJournalSpin .8s linear infinite;\n}\n\n@keyframes adminJournalSpin{\n  to { transform: rotate(360deg); }\n}\n\n/* Pagination */\n.adminJournalPagination{\n  margin-top: 14px;\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  gap: 10px;\n}\n\n.adminJournalPageBtn{\n  width: 36px;\n  height: 36px;\n  border-radius: 12px;\n  border: 1px solid rgba(0,0,0,.08);\n  background: var(--white-principale);\n  cursor: pointer;\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  transition: filter .15s ease;\n}\n\n.adminJournalPageBtn:hover{\n  filter: brightness(0.98);\n}\n\n.adminJournalPageBtn:disabled{\n  opacity: .55;\n  cursor: default;\n}\n\n.adminJournalPageInfo{\n  font-size: 12px;\n  color: var(--gris-terciaire);\n}\n\n/* Responsive */\n.hideOnMobile { display: table-cell; }\n.adminJournalMobileMeta { display: none; }\n\n@media (max-width: 720px){\n  .hideOnMobile { display: none !important; }\n\n  .adminJournalTable{ min-width: 0; }\n  .adminJournalTable thead{ display:none; }\n\n  .adminJournalTable,\n  .adminJournalTableWrap{\n    border: none;\n  }\n\n  .adminJournalTable tbody{\n    display:flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .adminJournalTable tbody tr{\n    display:block;\n    border: 1px solid var(--gris-secondaire-2);\n    border-radius: 14px;\n    padding: 10px;\n    background: var(--white-principale);\n  }\n\n  .adminJournalTable tbody td{\n    display:block;\n    border-bottom: none;\n    padding: 6px 4px;\n  }\n\n  .colActions{\n    width: auto;\n  }\n\n  .adminJournalActions{\n    justify-content: flex-end;\n    margin-top: 6px;\n  }\n\n  .adminJournalMessage{\n    -webkit-line-clamp: 3;\n    max-width: 100%;\n  }\n\n  .adminJournalMobileMeta{\n    display:block;\n    margin-top: 8px;\n    font-size: 11px;\n    color: var(--gris-terciaire);\n    line-height: 1.35;\n  }\n\n  .adminJournalMobileMeta div{\n    display:flex;\n    align-items:center;\n    gap: 8px;\n    margin-top: 4px;\n  }\n\n  .adminJournalMobileMeta i{\n    opacity: .8;\n  }\n}\n\n/* Modal de confirmation (suppression) */\n.adminJournalModalOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  padding: 16px;\n}\n\n.adminJournalModal {\n  width: 100%;\n  max-width: 390px;\n  background: var(--white-principale);\n  border-radius: 18px;\n  padding: 22px;\n  text-align: center;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.22);\n  animation: adminJournalModalIn 0.18s ease;\n}\n\n@keyframes adminJournalModalIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.adminJournalModalIcon {\n  width: 52px;\n  height: 52px;\n  border-radius: 999px;\n  margin: 0 auto 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(220, 53, 69, 0.1);\n  color: #dc3545;\n  font-size: 24px;\n}\n\n.adminJournalModal h3 {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 900;\n  color: var(--couleur-dark);\n}\n\n.adminJournalModal p {\n  margin: 10px 0;\n  font-size: 13px;\n  color: var(--gris-terciaire);\n  line-height: 1.45;\n}\n\n.adminJournalModalActions {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin-top: 18px;\n}\n\n.adminJournalModalCancel,\n.adminJournalModalConfirm {\n  border: none;\n  border-radius: 999px;\n  padding: 9px 16px;\n  font-size: 12px;\n  font-weight: 900;\n  cursor: pointer;\n}\n\n.adminJournalModalCancel {\n  background: rgba(0, 0, 0, 0.07);\n  color: var(--couleur-dark);\n}\n\n.adminJournalModalConfirm.danger {\n  background: #dc3545;\n  color: #fff;\n}\n\n.adminJournalModalCancel:hover,\n.adminJournalModalConfirm:hover {\n  filter: brightness(0.96);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
